import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropertiesItem } from '@/components/Ad/Properties/PropertiesItem';
import { useAdDetails } from '@/views/Ads/useAdDetails';
import { Divider } from '@/components/UI/Divider/Divider.styles';

export const Properties = () => {
  const { t } = useTranslation();
  const { adDetails } = useAdDetails();

  const cityProperty = {
    name: t('common.city'),
    value: adDetails?.region || t('common.no'),
    link: null,
  };

  return (
    <>
      {adDetails
        ? [cityProperty, ...adDetails.properties].map(property => (
            <PropertiesItem key={property.name} adProperty={property} />
          ))
        : Array.from({ length: 5 }, (_, index) => (
            <PropertiesItem key={index} />
          ))}
      <Divider $isSmall />
    </>
  );
};
